import { Fragment } from "react";
import { useSelector } from "react-redux";
import { BASENAME } from "../../../utils/basename";
import LazyLoadImg from "../../shared/lazyLoadImg/LazyLoadImg";

const BloccoIconeFooter = () => {
  const vociIconeTranslation = useSelector(
    (state) => state.translations.iconeMenuLeft
  );

  return (
    <Fragment>
      <div className="flex items-center mr-4 mb-2 sm:mb-4">
        <span className="font-opensanssemibold text-ribola-congress-blue mr-2 text-lg">
          {vociIconeTranslation.resoGratuito.itemName.toUpperCase()}
        </span>
        <div className="w-8 h-auto flex justify-center items-center">
          <LazyLoadImg
            imgName="reso_gratuito.svg"
            imgPath="../images"
            imgWidth="79"
            imgHeight="78"
            imgStyle="flex-start p-1 sm:p-0"
            imgAlt={vociIconeTranslation.resoGratuito.itemName}
          />
        </div>
      </div>
      <div className="flex items-center">
        <span className="font-opensanssemibold text-ribola-congress-blue mr-2 text-lg">
          {vociIconeTranslation.assistenza.itemName.toUpperCase()}
        </span>
        <div className="w-8 h-auto flex justify-center items-center">
          <LazyLoadImg
            imgName="assistenza.svg"
            imgPath="../images"
            imgWidth="80"
            imgHeight="70"
            imgStyle="flex-start p-1 sm:p-0"
            imgAlt={vociIconeTranslation.assistenza.itemName}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default BloccoIconeFooter;
